<template>
	<div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"
					   rowKey="id" :pagination="false" :scroll="{y:500}">
			<span slot="validName"  slot-scope="text, record">
				{{record.valid==1 ? '已发送' :'未发送'}}
			</span>
			<span slot="theAction" slot-scope="text, record">
				<a-button :loading="submitFlag"  v-if=" record.valid == 0 "  size="small" icon="mail" type="link" @click="sendSms(record)">发送欠费短信</a-button>
			</span>
		</a-table>
	</div>
</template>

<script>
	const  columns=[
		{
			title: '小区名称',
			dataIndex: 'neighborname',
			width:150
		},
		{
			title: '楼',
			dataIndex:'lou',
			width:50,
		},
		{
			title: '单元',
			dataIndex:'danyuan',
			width:60,
		},
		{
			title: '户',
			dataIndex:'hu',
			width:50,
		},
		{
			title: '客户名称',
			dataIndex:'customersname',
			width:110,
		},
		{
			title: '生成时间',
			dataIndex:'date',
			width:240,
		},
		{
			title: '电话',
			dataIndex:'phone',
			width:160,
		},
		{
			title: '余额',
			dataIndex:'balance',
			width:80,
		},
		{
			title: '是否发送短信',
			dataIndex:'valid',
			width:150,
			scopedSlots: { customRender: 'validName' },
		},
		{
		    title: '操作',
		    key: 'pid',
		    scopedSlots: { customRender: 'theAction' },
			width:110,
			align:'center',
		  },
	];
	export default{
		props:['taskId','neighborId','houseKind'],
		data(){
			return{
				columns,
				list:[],
				loading:true,
				submitFlag:false,
			}
		},
		methods:{
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.SCANNING_TASK_ARREARAGE_CUSTOMERS_URL);
				let param = {taskId:this.taskId,neighborId:this.neighborId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			sendSms:function(item){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.SCANNING_TASK_ARREARAGE_SENDSMS_URL);
				let param = {theId:item.id};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('欠费短信发送成功');
						this.queryDataList();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				});
			},
		},
		created() {
			this.queryDataList();
		}
	}
</script>

<style>
</style>
